import { Type, Transform } from 'class-transformer'
import { DateTime } from 'luxon'

export default class Lead {
  id!: number
  user_id!: number | null
  practice_id!: number | null
  first_name!: string
  last_name!: string
  email!: string
  phone!: string
  practice_name!: string
  parent_company!: string

  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  created_at!: DateTime

  can_access_lead!: boolean
  cannot_access_lead_reason!: string
  can_edit_lead!: boolean
  cannot_edit_lead_reason!: string

  practice_is_stripe_ready!: boolean
  practice_not_stripe_ready_reason!: string

  num_checks_total!: number
  num_checks_waiting_nurse!: number
  num_checks_waiting_confirmation!: number
  num_checks_booking_confirmed!: number
}
